import type { ReactNode } from "react";

/** Finversify's layered mark: three stacked chevrons, papaya over midnight. */
export function Mark({ size = 28 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
      <path d="M4 20 16 26 28 20" fill="none" stroke="#E96616" strokeWidth="3" strokeLinejoin="round" />
      <path d="M4 14.5 16 20.5 28 14.5" fill="none" stroke="#E96616" strokeWidth="3" strokeLinejoin="round" />
      <path d="M8 9.5 16 5 24 9.5" fill="none" stroke="#A5BDFB" strokeWidth="3" strokeLinejoin="round" />
    </svg>
  );
}

export function Shell({ children, right }: { children: ReactNode; right?: ReactNode }) {
  return (
    <>
      <header className="topbar">
        <div className="topbar-inner">
          <a className="brand" href="#/">
            <Mark />
            Finversify
          </a>
          {right}
        </div>
      </header>
      <main>{children}</main>
      <footer className="footer">
        <p>
          Finversify is a SEBI-registered Research Analyst, registration no. INH200008608. Registration granted by SEBI and certification from
          NISM in no way guarantee performance of the intermediary or provide any assurance of returns to investors.
        </p>
        <p>Investments in the securities market are subject to market risks. Read all related documents carefully before investing.</p>
      </footer>
    </>
  );
}

export function Notice({ tone = "info", children }: { tone?: "info" | "good" | "bad" | "warn"; children: ReactNode }) {
  return (
    <div className={`notice ${tone === "info" ? "" : tone}`} role={tone === "bad" ? "alert" : "status"}>
      {children}
    </div>
  );
}

const STEPS = ["Your details", "KYC", "Agreements", "Plan and payment"] as const;

export function Steps({ current }: { current: 0 | 1 | 2 | 3 }) {
  return (
    <ol className="steps" aria-label="Sign-up progress">
      {STEPS.map((label, i) => (
        <li key={label} className={i < current ? "done" : i === current ? "current" : ""} aria-current={i === current ? "step" : undefined}>
          {label}
        </li>
      ))}
    </ol>
  );
}

/** Test-mode stand-in for a partner's screen, clearly marked so nobody mistakes it for the real thing. */
export function SandboxPanel({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section className="sandbox" aria-label={title}>
      <h3>{title}</h3>
      <p className="small muted">Test mode. In live mode this step opens the real provider's screen.</p>
      {children}
    </section>
  );
}
